export const DEFAULT_ERROR = 'Something went wrong.'
export const DEFAULT_SUCCESS = 'Changes saved successfully'

export const ERROR_PATH = ['response', 'data', 'detail']
